module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.8067c90.eot";